
import { Mixin } from 'vue-mixin-decorator';
import Vue from 'vue';
import UtilsService from '@/core/services/utils.service';
import { toUnicode } from 'punycode';

@Mixin
class ErrorMixin extends Vue {

    public error: any = {};
    public parentNode: any = '';


    public scrollTo(elementToScroll: any) {
        if (this.parentNode !== '') {
            const element = elementToScroll;
            const adjust = -20;
            if ( this.parentNode && element ) {
                this.parentNode.scrollTop = element.offsetTop + adjust;
            }
        } else {
            // tslint:disable-next-line:no-console
            console.log('error.mixin - Establish parentNode');
        }
    }

    private getErrorObject(fields: string, callback = (a: any, b: any) => { const doNothing = 1; }) {
        const keys = fields.split('.');
        let resultObject: any = {};
        if ( !UtilsService.objectIsEmpty(this.error) ) {
            resultObject = this.error;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < keys.length; i++) {
                let lastResultObject;
                let lastKey;
                let makeArray = false;
                let indexArray = 0;
                if (keys[i].includes('[')) {
                    makeArray = true;
                    const keySplitted = keys[i].split('[');
                    indexArray = Number(keySplitted[1].split(']')[0]);
                    keys[i] = keySplitted[0];
                }
                if ( resultObject === undefined || !resultObject[keys[i]] ) {
                    break;
                } else if ( makeArray && UtilsService.objectIsEmpty(resultObject) ) {
                    break;
                } else {
                    if ( makeArray ) {
                        resultObject = resultObject[keys[i]][indexArray];
                    } else {
                        lastResultObject = resultObject;
                        lastKey = keys[i];
                        resultObject = resultObject[lastKey];
                    }
                }
                if ( (i + 1) === keys.length ) {
                    callback(lastResultObject, lastKey);
                }
            }
        }
    }

    public hideError(fields: string): void {
        this.getErrorObject(fields, (object: any, key: any) => {
            object[key] = '';
        });
    }


    public getError(fields: string) {
        let errorMessage = '';

        this.getErrorObject(fields, (object: any, key: any) => {
            errorMessage = object[key];
        });
        if ( Array.isArray(errorMessage) ) {
            errorMessage = errorMessage[0];
        }

        return errorMessage;
    }


    get hasError() {
        let error = false;
        const keys = Object.keys(this.error);
        keys.forEach((key: string) => {
            if ( this.error[key] !== '' ) {
                error = true;
            }
        });
        return error;
    }

}

export default ErrorMixin;
